import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import logo from '../assets/img/logo2.png';

const PasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/api/auth/password-reset/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (response.ok) {
        setSubmitted(true);
      } else {
        const data = await response.json();
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-4">
        <Link to="/" className="mb-8">
          <img src={logo} alt="Dorito Stats" className="h-14" />
        </Link>
        <div className="w-full max-w-sm bg-ds-white border border-border-card rounded-card shadow-card p-8 text-center">
          <CheckCircle className="w-10 h-10 text-green mx-auto mb-4" />
          <h1 className="font-display text-2xl font-black text-ds-text mb-2">
            Check your email
          </h1>
          <p className="text-text-muted text-sm mb-6">
            If that email is registered, a password reset link has been sent.
          </p>
          <Link
            to="/login"
            className="text-green font-semibold text-sm hover:text-mustard transition-colors"
          >
            ← Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-4">
      <Link to="/" className="mb-8">
        <img src={logo} alt="Dorito Stats" className="h-14" />
      </Link>

      <div className="w-full max-w-sm bg-ds-white border border-border-card rounded-card shadow-card p-8">
        <h1 className="font-display text-2xl font-black text-ds-text mb-1">
          Reset password
        </h1>
        <p className="text-text-muted text-sm mb-6">
          Enter your email and we'll send you a reset link.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="you@example.com"
            />
          </div>

          {error && (
            <p className="text-coral text-sm font-semibold">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-mustard text-forest font-extrabold text-sm py-2.5 rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors disabled:opacity-60"
          >
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>

        <p className="mt-4 text-sm text-text-muted">
          <Link to="/login" className="text-green font-semibold hover:text-mustard transition-colors">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PasswordResetPage;
